import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import SubcategoryList from './SubcategoryList';

const ViewSubcategory = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Category" title="Subcategory List" mainTitle="Category List" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <SubcategoryList />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default ViewSubcategory